<button [ngClass]="buttonClasses" (click)="onClick()">
  <img [src]="'assets/icons/' + buttonIcon + '.svg'" alt="icon" class="button-icon" />
</button>
